<template>
  <v-card text>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex md6>
            <v-text-field
              v-model="candidateName"
              :disabled="!!existingCampaign"
              :rules="rules"
              label="Candidate Name"
            />
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="campaignName"
              :disabled="!!existingCampaign"
              :rules="rules"
              label="Campaign Name"
            />
          </v-flex>
          <v-flex md6>
            <v-select
              :items="campaignTypes"
              :disabled="!!existingCampaign"
              :rules="rules"
              item-text="name"
              item-value="value"
              v-model="campaignType"
              label="Campaign Type"
            />
          </v-flex>
          <v-flex md6>
            <v-select
              :items="states"
              :disabled="!!existingCampaign"
              item-text="name"
              :rules="rules"
              v-model="state"
              label="State"
            />
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="district"
              :disabled="!!existingCampaign"
              :rules="rules"
              label="District #"
            />
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!valid"
        @click.native="next"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import states from '../../../../static/states'
import campaignTypes from '../../../../static/campaign-types'
import gettingStartedItems from '../../../../static/setup-checklist-items'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'StepperContentOne',
  data () {
    return {
      valid: true,
      candidateName: '',
      campaignName: '',
      campaignType: 'us_house',
      state: 'New York',
      states: [],
      campaignTypes: [],
      rules: [v => !!v || 'Field is required'],
      district: '5',
      reviewFileUrl: null,
      file: null
    }
  },
  props: {
    existingCampaign: {
      type: Object,
      default: () => {}
    },
    advertiserType: {
      type: String,
      default: 'political_campaign'
    }
  },
  created () {
    this.states = states
    this.campaignTypes = campaignTypes
  },
  mounted () {
    if (this.existingCampaign) {
      this.candidateName = this.existingCampaign.political.candidate_name
      this.campaignName = this.existingCampaign.name
      this.campaignType = this.existingCampaign.political.campaign_type
      this.state = this.existingCampaign.political.state
      this.district = this.existingCampaign.political.district
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      advertisers: 'getAdvertisers'
    })
  },
  methods: {
    next () {
      if (!this.existingCampaign) {
        if (this.$refs.form.validate()) {
          const advertiser = {
            name: this.campaignName,
            ad_account: null,
            fb_page_id: null,
            type: this.advertiserType,
            political: {
              campaign_type: this.campaignType,
              candidate_name: this.candidateName,
              state: this.state,
              district: this.district
            },
            setupMode: {
              status: true,
              items: gettingStartedItems
            }
          }
          new Promise(resolve => {
            resolve(this.$store.dispatch('createAdvertiser', advertiser))
          })
            .then(res => {
              this.$emit('setAdvertiser', res)
            })
        }
      } else {
        const advertiser = this.advertisers.find(a => a.data.fb_page_id === this.existingCampaign.fb_page_id)
        this.$emit('setAdvertiser', advertiser.id)
      }
    },
    createReviewURL () {
      const file = this.$refs.file.files[0]
      if (!file) return false
      const allowFileTypes = ['image/gif', 'image/png', 'image/jpg', 'image/jpeg']
      if (!allowFileTypes.find(type => type === file.type)) {
        this.showNotification({
          type: 'warning',
          message: ['Next file types allowed: gif, png, jpg, jpeg']
        })
        return false
      }
      this.reviewFileUrl = URL.createObjectURL(file)
      this.file = file
    },
    ...mapActions([
      'showNotification'
    ])
  }
}
</script>
